import React, { useState } from 'react'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Tooltip from '@mui/material/Tooltip'
import { useHistory } from 'react-router-dom'
import { MenuProps } from '~/components/SidebarMenu/interfaces'
import { useLang } from '~/hooks/useLang'
import { Collapse, List } from '@mui/material'
import userUserState from '~/features/User/stores/UserState'

import { ExpandLess, ExpandMore } from '@mui/icons-material'

export default function ReportByQualifiers({ handleMenuClick }: MenuProps) {
  const { translate } = useLang()
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const { verifyPermission } = userUserState()

  const handleClickOpen = () => {
    setOpen((old) => !old)
  }

  return (
    <>
      <Tooltip
        title={translate('Generate report') + ' ' + translate('Qualifiers')}
        placement="right"
      >
        <ListItemButton onClick={handleClickOpen}>
          <ListItemText primary={translate('Qualifiers')} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {verifyPermission(['reports_generator']) && (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {verifyPermission(['report_qualifiers_searches_per_user']) && (
                <Tooltip
                  title={
                    `${translate('Generate report')}` +
                    ' ' +
                    `${translate('Qualifiers')}`
                  }
                  placement="right"
                >
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      handleMenuClick('reports')
                      history.push('/report/total-qualifiers-searches-by-user')
                    }}
                  >
                    <ListItemText
                      primary={translate('Total qualifiers searches per user')}
                    />
                  </ListItemButton>
                </Tooltip>
              )}

              {verifyPermission(['report_qualifiers_records_by_options']) && (
                <Tooltip
                  title={
                    `${translate('Generate report')}` +
                    ' ' +
                    `${translate('Registration of qualifiers')}`
                  }
                  placement="right"
                >
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      handleMenuClick('reports')
                      history.push('/report/report-qualifiers-by-options')
                    }}
                  >
                    <ListItemText
                      primary={translate('Registration of qualifiers')}
                    />
                  </ListItemButton>
                </Tooltip>
              )}
            </>
          )}
        </List>
      </Collapse>
    </>
  )
}
